import { render } from "./DettagliPerizia.vue?vue&type=template&id=faaf12b8&scoped=true"
import script from "./DettagliPerizia.vue?vue&type=script&lang=js"
export * from "./DettagliPerizia.vue?vue&type=script&lang=js"

import "./DettagliPerizia.vue?vue&type=style&index=0&id=faaf12b8&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faaf12b8"]])

export default __exports__